<template>
	<div class="index min-w">
		<header-view :tabsign='0' :ifclass='ifclass'></header-view>
		<imgrotation :resultStr='JSON.stringify(resultInfo)'></imgrotation>
		
		<div class="centercon">
			<div class="newcenter w12 min-h">
				<div class="tipcon">
					<div class="r_c">
						<div class="title">新闻中心</div>
						<div class="line"></div>
					</div>
					<div class="l_c" @click="toNotice">查看更多</div>
				</div>
				
				<div class="carcon">
					<div class="black_left">
						<newsrotation></newsrotation>
					</div>
					<div class="black_right">
						<newscontent @receiveSign="receiveSign"></newscontent>
					</div>
				</div>
				
				<div class="helpcon">
					<el-image fit='cover' @click="tohelp" class="imgcon" :src="require('../../assets/newimg/applyhelp@2x.png')" alt="" ></el-image>
				</div>
				
				<div class="tipcon">
					<div class="r_c">
						<div class="title">推荐公益项目</div>
						<div class="line"></div>
					</div>
					<div class="l_c" @click="topublicwel">查看更多</div>
				</div>
							
			</div>
			
			<div class="welfarepro">
				<welfareroll></welfareroll>
			</div>
			
			<div class="beneactivite">
				<div class="img_c">
					<div class="title">公益活动</div>
					<div class="linecon"><div class="line"></div></div>
					<div class="name">青海省青少年发展基金会</div>
				</div>
				<div class="threedrotate">
					<threedrotate></threedrotate>
				</div>
			</div>
			
			<div class="scopebus">
				<div class="right_c">
					<el-image fit='cover' class="imgcon" :src="require('../../assets/newimg/scopebus@2x.png')" alt="" ></el-image>
				</div>
				<div class="left_c">
					<div class="lista">业务范围</div>
					<div class="listb">
						<div class="line"></div>
					</div>
					<div class="listc">
						<p> 本基金会公益活动的业务范围是：</p> 
						<p>(一)组织实施符合本基金会希望工程公益使命的资助、服务和救灾援助项目； </p>
						<p>(二)组织开展和资助开展有益于青少年身心健康的各项活动；</p>
						<p>(三)支持并组织实施青少年研究和慈善组织发展的研究； </p>
						<p>(四)奖励青少年优秀人才及为青少年事业做出杰出贡献的个人和团体； </p>
						<p>(五)开展与省内外、国内外公益组织和爱心人士以及国际青少年组织、慈善组织的友好交流与合作。</p>			
					</div>
				</div>
			</div>
			
			<div class="lovemessage">
				<div class="r_con">
					<div class="toptitle">
						<div class="title">爱心留言</div>
						<div class="line"></div>
					</div>
					<div class="subimcon">
						<div class="imgcar">
							<el-image fit='cover' :src="require('../../assets/newimg/lovemessage@2x.png')" alt="" ></el-image>
						</div>
					
						<div class="inputcon">
							<div class="title">您填写的爱心留言我们会认真的查看哦~</div>
							<el-form :model="ruleForm" label-position="left" ref="ruleForm" label-width="0px" :rules="rules">
								<div class="item-row">
									<el-form-item prop="contractName" style="width: 180px;margin-right: 14px;">
										<el-input  v-model="ruleForm.contractName" placeholder="您的称呼"></el-input>
									</el-form-item>
									<el-form-item prop="contractPhone" style="width:180px">
										<el-input v-model="ruleForm.contractPhone" placeholder="联系方式"></el-input>
									</el-form-item>
								</div>
								<el-form-item prop="collectContent">
									<el-input class="resizeNone" resize="none"
									type="textarea"
									maxlength="200" show-word-limit
									:autosize="{ minRows: 3, maxRows: 3}"
									placeholder="爱心留言"
									v-model="ruleForm.collectContent">
									</el-input>
								</el-form-item>
								<div class="btncon">
									<div class="btn" @click="add()">提交留言</div>
								</div>
							</el-form>
							
						</div>
					</div>
					
				</div>
				<div class="l_con">
					<div class="qrcon">
						<div class="topcon">
							<img src="../../assets/newimg/fengche.png" alt="" />
							<span>希望工程公众号</span>
						</div>
						<div class="imgcon">
							<el-image fit='cover' class="img" :src="require('../../assets/newimg/QRcode.jpg')" alt="" />
						</div>
					</div>
				</div>
			</div>
			
		</div>
		
		
	</div>
	
</template>

<script>
import { formatMoney } from '@/utils/util';
import imgrotation from '@/com/imgrotation.vue';
import newsrotation from '@/com/newsrotation.vue';
import newscontent from '@/com/newscontent.vue';
import welfareroll from '@/com/welfareroll.vue';
import threedrotate from '@/com/threedrotate.vue';
export default {
	 components: {
	    imgrotation,
		newsrotation,
		newscontent,
		welfareroll,
		threedrotate,
	 },
	  data() {
			return {
				signtype:0,
				resultInfo:{},//
			    ifclass:true,
				ruleForm:{
					contractName:"",
					contractPhone:"",
					collectContent:"",
				},
				rules: {
					contractName: [
						{
							required: true,
							message: "请输入个人姓名",
							trigger: ["blur", "change"],
						}, 
					],
					contractPhone: [
						{
							required: true,
							message: "请输入联系方式",
							trigger: ["blur", "change"],
						},
						{
							pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
							message: "手机号码不对",
							trigger: ["blur", "change"],
						},
					],
					collectContent: [
						{
							required: true,
							message: "请输入爱心留言",
							trigger: ["blur", "change"],
						}, 
					],
				},
			};
	  },
	  
	  destroyed() {
	        document.removeEventListener('scroll', this.handleScroll)
	  },
	  created(){
		  this.getHomeMoneySum()
	  },
	  mounted() {
	  		window.addEventListener("scroll",this.handleScroll); 
	  },
	  
	  methods: {
			getHomeMoneySum() {
				this.httpGet("/web/statisticsController/getHomeMoneySum").then(res => {
						if(res.result){  
							this.resultInfo=res.result;
							// this.pricelist[0] = formatMoney(result.mothMoney||0,0)
							// this.pricelist[1] = formatMoney(result.yearMoney||0,0)
							// this.pricelist[2] = formatMoney(result.hisMoney||0,0)
						}
						
				});
			},
		  	add(){
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						var param = this.ruleForm
						this.httpPost("web/loveMessage/addLoveMessage", param).then(res => {
							if(res.success){
								this.ruleForm={ 
									contractName:"",
									contractPhone:"",
									collectContent:"",
								}
								this.$forceUpdate();
								this.$message.success("提交成功！");
							}	    
						});	
					} else {
						return false;
					}
				});
			},			
		    receiveSign(sign){
				this.signtype = sign
			},
		  
		    handleScroll() {
		        //获取滚动时的高度
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// console.log("滚动高度"+scrollTop)
				if(scrollTop >= 800){
					this.ifclass = false;
				}else{
					this.ifclass = true;
				}
			},
					
			toNotice(){
				if(this.signtype == 0){
					this.$router.push({ path: '/newscenter', query: {} });
				}else if(this.signtype == 1){
					this.$router.push({ path: '/publicannounce', query: {} });
				}				
			},
						
			tohelp(){
				this.$router.push({ path: '/applyforhelp', query: {} });
			},
			
			topublicwel(){
				this.$router.push({ path: '/publicwelpro', query: {} });
			},
			
			
	  },
	  
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.index{
	.centercon{
		margin-bottom: 100px;
		.newcenter{
			margin:0px auto;
			.tipcon{
				margin-top: 30px;
				height: 100px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #DCDCDC;
				.r_c{
					font-size: 30px;
					font-weight: 400;
					color: #333333;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					height: 100px;
					.title{
						padding-top: 20px;
					}
					.line{
						width: 67px;
						height: 3px;
						background: #DD3039;
					}
				}
				.l_c{
					cursor: pointer;
					font-size: 14px;
					font-weight: 400;
					color: #999999;
				}
			}
			
			.carcon{
				display: flex;
				margin-top: 60px;
				.black_left{
					flex: 1;
				}
				.black_right{
					flex: 1;
					margin-top: -45px;
					min-height: 480px;
				}
			}
			
			.helpcon{
				margin-top: 40px;
				.imgcon{
					height: 200px;
					width: 1200px;
					cursor: pointer
				}
			}
						
		}
		
		.welfarepro{
			margin: 20px auto;
			width: 1300px;
			min-height: 500px;			
		}
		
		.beneactivite{
			margin: 20px auto;
			width: 1200px;
			min-height: 600px;
			display: flex;
			align-items: center;
			.img_c{
				margin-right: 40px;
				height: 662px;
				width: 280px;
				background: url(../../assets/newimg/drotateimg@2x.png) no-repeat center / 100% 100%;
				.title{
					text-align: center;
					margin-top: 40px;
					margin-bottom: 20px;
					font-size: 30px;
					font-weight: 400;
					color: #000000;
				}
				.linecon{
					display: flex;
					justify-content: center;
					.line{
						width: 66px;
						height:2px;
						background: #D80C18;
					}
				}
				
				.name{
					margin-top: 20px;
					text-align: center;
					font-size: 20px;
					font-weight: 400;
					color: #666666;
				}
			}
			.threedrotate{
				
			}
		}
		
		.scopebus{
			margin-top: 40px;
			min-width: 1200px;
			min-height: 400px;
			display: flex;
			align-items: center;
			.right_c{
				flex: 1;
				width: 50.052%;
				.imgcon{
					height: 310px;
					width: 100%;
				}
			}
			.left_c{
				width: 49.948%;
				.lista{
					height: 60px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size:30px;
					font-weight: 400;
					color: #333333;
					// width: calc(100% - 80px);
				}
				.listb{
					display: flex;
					align-items: center;
					justify-content: center;
					// width: calc(100% - 80px);
					.line{
						width: 66px;
						height: 2px;
						background: #D80C18;
					}
				}
				.listc{
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					font-size: 16px;
					font-weight: 400;
					color: #666666;
					padding: 20px;
					// padding-right: 80px;
					line-height: 1.2;
					box-sizing: border-box;
				}
			}
		}
		
		.lovemessage{
			margin: 20px auto;
			width: 1200px;
			min-height: 400px;
			display: flex;		
			.r_con{
				flex: 2;
				.toptitle{
					font-size: 30px;
					font-weight: 400;
					color: #333333;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					height: 100px;
					border-bottom: 1px solid #DCDCDC;
					.title{
						padding-top: 20px;
					}
					.line{
						width:67px;
						height: 3px;
						background: #DD3039;
					}
					
				}
				.subimcon{
					display: flex;
					align-items: center;
					min-height: 300px;
					margin-top: 20px;
					.imgcar{
						margin-left: 20px;
						margin-right:20px;
						.el-image{
							width: 260px;
							height: 160px;
						}
					}
					.inputcon{
						width: calc(100% - 300px);
						.item-row{
							display: flex;
							justify-content: flex-start;
							align-items: center;
							width: 100%;
							.el-form-item{
								margin-bottom: 10px;
							}
						}
						
						.title{
							height: 60px;
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: 16px;
							font-weight: 400;
							color: #797979;
						}
						.btncon{
							height: 60px;
							display: flex;
							align-items: center;
							justify-content: center;
							.btn{
								cursor: pointer;
								width: 120px;
								height: 32px;
								line-height: 32px;
								text-align: center;
								background: #E50112;
								border-radius:15px;
								font-size:16px;
								font-weight: 400;
								color: #FFFFFF;
							}
						}
						.resizeNone{
							margin-top: 20px;
						}
						
					}					
					
				}
			}
			.l_con{
				flex: 0.7;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-left: 40px;
				.qrcon{
					width: 319px;
					background: #FFFFFF;
					border: 1px solid #EDEDED;
					.topcon{
						height: 49px;
						background: #E50112;
						border: 1px solid #E50112;
						display: flex;
						align-items: center;
						img{
							width: 22px;
							height:22px;
							margin-left: 10px;
							margin-right:10px;
						}
						span{
							font-size: 20px;
							font-weight: 400;
							color: #FFFFFF;
						}
					}
					.imgcon{
						display: flex;
						align-items: center;
						justify-content: center;
						height: 240px;
						.img{
							width: 128px;
							height: 128px;
						}
					}
					
				}
				
			}			
		}
		
		
		
	}
	
	
	
	
}

</style>
